import { useNavigate, useParams } from "react-router-dom";
import { useMenuContext } from "../../StateManagement/Contexts/MenuContext";
import { useEffect, useState } from "react";

const MenuContentPage = () => {
  const params = useParams();
  const { selectedMenuItem: menuData } = useMenuContext();
  const [content, setContent] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    if (!menuData) {
      return;
    }
    const foundedData = menuData?.find(
      (data) => data.id.toString() === params.id.toString()
    );
    if (foundedData) {
      setContent({ ...foundedData });
    } else {
      navigate("/");
    }
  }, [menuData, params, navigate]);

  return (
    <div className="mt-2  px-4">
      <div className="card px-3 wd-75 wm-100 m-auto">
        <div className="card-body  ">
          <p className="fs-4 fw-bold text-center">
            {content?.title?.split("|")[1]}
          </p>
          <hr />
          <div
            className="overflow-x-auto"
            dangerouslySetInnerHTML={{ __html: content?.txt }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default MenuContentPage;
